import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';

const api = callApi(API_BASE_URL || "");

export const GET_TEACHER_DASHBOARD_SUMMARY = '/v1/api/teacher/dashboard/summary';
export const GET_TEACHER_DASHBOARD_GRADE_SECTIONS = '/v1/api/teacher/dashboard/grade-sections';
export const GET_TEACHER_MY_GRADES_SECTIONS = '/v1/api/teacher/dashboard/my-grades-sections';
export const GET_TEACHER_STUDENTS = '/v1/api/teacher/dashboard/students';
export const GET_TEACHER_DASHBOARD_INSIGHTS = '/v1/api/teacher/dashboard/insights';

export const getTeacherSummaryApi = async () => api.get(GET_TEACHER_DASHBOARD_SUMMARY);
export const getTeacherGradeSectionsApi = async () => api.get(GET_TEACHER_DASHBOARD_GRADE_SECTIONS);
export const getTeacherMyGradesSectionsApi = async () => api.get(GET_TEACHER_MY_GRADES_SECTIONS);
export const getTeacherInsightsApi = async () => api.get(GET_TEACHER_DASHBOARD_INSIGHTS);

export const getTeacherStudentsApi = async (params = {}) => {
    const merged = { pageNumber: 0, pageSize: 50, sortOrder: true, sortBy: 'createdAt', ...params };
    const cleaned = Object.fromEntries(
        Object.entries(merged).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );
    const query = new URLSearchParams(cleaned).toString();
    return api.get(`${GET_TEACHER_STUDENTS}?${query}`);
};
